<template>
    <div class="profile-container">
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img" :style="{ height: computeHeight }" />
            </el-carousel-item>
        </el-carousel>
        <div class="solve">
            <div class="f-label font_size_30">公司简介</div>
            <div class="s-label font_size_14">PROFILE</div>
        </div>
        <div class="profile">
            <img src="../../assets/profile/37@2x.png" class="left-img" />
            <div class="right">
                <p class="content">
                    公司创立于2022年11月，是邮你采联合行业专家及互联网技术精英团队共同注资成立，致力于成为一家创新型医药科技公司。
                    邮你采倡导“原厂原标、一店发全国”的工业直销模式，努力缩短工业与终端的距离，为推进健康中国战略贡献力量。
                    公司利用先进的商业模式和强大的技术力量，实现了药品全流程数字化追踪。
                    通过专业的医药数字化交易服务平台，连接供需两端，推动医疗健康生态系统的进步。
                    以业务创新和技术革新为双轮驱动力，重塑医药流通价值链，致力于构建一个医药流通无界交融的新格局。
                </p>
                <img src="../../assets/profile/34@2x.png" class="right-bottom-img" />
            </div>
        </div>
        <div class="solve" style="background-color: #f8f8f8">
            <div class="f-label font_size_30">我们的模式</div>
            <div class="s-label font_size_14">MODE</div>
        </div>
        <div class="mode">
            <div class="mode-top">
                <div class="mode-top-left">
                    <div class="title">B2B模式</div>
                    <div class="content">
                        医药电商的价值主张主要体现在方便快捷、多样性和个性化、提高效率和节约成本、增加市场机会以及提高社会价值等方面。在不断发展的互联网技术和社会需求推动下，医药电商将成为医药行业未来发展的重要趋势之一。
                    </div>
                </div>
                <img src="../../assets/profile/3@2x.png" class="mode-top-img" />
            </div>
            <div v-if="seen" class="mode-bottom">
                <div class="mode-bottom-left-btn" @click="clickHanlde('left')"></div>
                <div class="mode-bottom-box">
                    <div id="modeList" style="display: flex">
                        <div
                            id="modeListItem"
                            v-for="(item, index) in modeList"
                            :key="index"
                            class="mode-bottom-box-item"
                        >
                            <img :src="item.img" class="img" />
                            <div class="title">{{ item.title }}</div>
                            <div class="content">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
                <div class="mode-bottom-right-btn" @click="clickHanlde('right')"></div>
            </div>
            <div v-else class="mode-bottom-mobile">
                <div
                    v-for="(item, index) in modeList"
                    :key="index"
                    class="mode-bottom-box-item"
                    :class="{
                        'mode-bottom-box-item-lone':
                            index === modeList.length - 1 && index % 2 === 0
                    }"
                >
                    <img :src="item.img" class="img" />
                    <div class="title">{{ item.title }}</div>
                    <div class="content">{{ item.content }}</div>
                </div>
            </div>
        </div>
        <div class="solve">
            <div class="f-label font_size_30">公司资质</div>
            <div class="s-label font_size_14">QUALIFICATION</div>
        </div>
        <div class="qualification">
            <div class="qualification-top">
                <div class="qualification-item mr100">
                    <div class="item-title">公司软件著作权</div>
                    <img src="../../assets/profile/8@2x.png" class="img-1" />
                </div>
                <div class="qualification-item">
                    <div class="item-title">公司商标注册</div>
                    <img src="../../assets/profile/9@2x.png" class="img-2" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProfilePage',
    data() {
        return {
            // sliders: [],
            modeList: [
                {
                    img: require('../../assets/profile/icon_sec3_1@2x.png'),
                    title: '药品供应与采购优化',
                    content:
                        '医药电商通过与药品流通企业和零售药店等合作，优化药品的采购、存储和配送流程，降低流通成本，提高药品供应的效率和质量。'
                },
                {
                    img: require('../../assets/profile/icon_sec3_2@2x.png'),
                    title: '多样性和个性化',
                    content: '医药电商可提供多样化的药品选择，包括处方药和非处方药、中药和西药等。'
                },
                {
                    img: require('../../assets/profile/icon_sec3_3@2x.png'),
                    title: '增加市场机会',
                    content: '医药电商可以借助互联网平台，拓展市场销售范围，覆盖更多的目标客户。'
                },
                {
                    img: require('../../assets/profile/icon_sec3_4@2x.png'),
                    title: '增强企业竞争力',
                    content:
                        '通过医药电商的数字化转型和创新升级，企业可以提高药品销售和服务效率，增强自身的市场竞争力，实现可持续发展。'
                },
                {
                    img: require('../../assets/profile/icon_sec3_5@2x.png'),
                    title: '提高社会价值',
                    content:
                        '医药电商可以帮助患者更好地管理和控制健康状况，减少不必要的医疗支出和药品浪费。'
                }
            ],
            screenWidth: document.body.clientWidth
        }
    },
    computed: {
        //计算高度
        computeHeight() {
            const m = 700 / 1920
            const mm = 210 / 375
            if (this.screenWidth > 768) {
                return (this.screenWidth * m).toFixed(2) + 'px'
            } else {
                return (this.screenWidth * mm).toFixed(2) + 'px'
            }
        },
        seen() {
            // 屏幕尺寸
            let screenWidth = document.body.clientWidth
            if (screenWidth > 768) {
                return true
            } else {
                return false
            }
        },
        sliders() {
            let screenWidth = document.body.clientWidth
            let arr = []
            if (screenWidth > 768) {
                arr = [{ img: require('../../assets/banner/banner4.png') }]
                return arr
            } else {
                arr = [{ img: require('../../assets/banner/banner4@2x.png') }]
                return arr
            }
        }
    },
    mounted() {
        const _this = this
        window.onresize = () => {
            return (() => {
                _this.screenWidth = document.body.clientWidth
            })()
        }
    },
    methods: {
        clickHanlde(pos) {
            const el = document.getElementById('modeList')
            const item = document.getElementById('modeListItem')
            const width = item.offsetWidth
            if (pos === 'right') {
                // el.style.transform = `translate(-710px,0)`
                el.style.transform = `translate(-${width * 2 + 40}px,0)`
                el.style.transition = 'transform .4s ease-in-out'
            } else if (pos === 'left') {
                el.style.transform = 'translate(0,0)'
                el.style.transition = 'transform .4s ease-in-out'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.profile-container {
    width: 100%;
}
.slider_img {
    height: 700px;
    width: 100%;
}

.font_size_30 {
    font-size: 1.875em;
}

.font_size_14 {
    font-size: 0.875rem;
}

.solve {
    padding-top: 50px;
    padding-bottom: 15px;
    position: relative;

    .f-label {
        text-align: center;
        color: #157e3b;
    }

    .s-label {
        text-align: center;
        color: #aaaaaa;
        margin-top: 10px;
    }

    .more-img {
        position: absolute;
        right: 19%;
        top: 65px;
        width: 77px;
        height: 32px;
        background-image: url('../../assets/main/pic_more_nor@2x.png');
        background-size: 100% 100%;
    }
}

.profile {
    width: 1069px;
    margin: 20px auto;
    display: flex;
    .left-img {
        width: 488px;
        height: 371px;
        margin: auto 0px;
    }

    .right {
        margin-left: 43px;
        .content {
            width: 522px;
            font-size: 1em;
            color: #333333;
            line-height: 28px;
        }

        .right-bottom-img {
            width: 538px;
            height: 186px;
            margin-top: 26px;
        }
    }
}

.mode {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f8f8f8;
    &-top {
        margin-top: 5px;
        display: flex;

        &-left {
            .title {
                font-size: 1.625rem;
                font-weight: bold;
                line-height: 28px;
            }
            .content {
                width: 437px;
                font-size: 1em;
                color: #333333;
                line-height: 28px;
                margin-top: 18px;
            }
        }
        &-img {
            width: 381px;
            height: 283px;
            margin-left: 121px;
        }
    }

    &-bottom {
        display: flex;
        margin-bottom: 45px;
        margin-top: 20px;
        align-items: center;
        &-left-btn {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background-image: url('../../assets//profile/arrow_left@2x.png');
            background-size: 100% 100%;

            &:hover {
                cursor: pointer;
                background-image: url('../../assets//profile/arrow_left_active@2x.png');
                background-size: 100% 100%;
            }
            // i {
            //     font-size: 1.875rem;
            //     margin: 11px;
            // }
        }

        &-right-btn {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background-image: url('../../assets//profile/arrow_right@2x.png');
            background-size: 100% 100%;
            &:hover {
                cursor: pointer;
                background-image: url('../../assets//profile/arrow_right_active@2x.png');
                background-size: 100% 100%;
            }
            // i {
            //     font-size: 1.875rem;
            //     margin: 11px;
            // }
        }

        &-box {
            width: 1060px;
            // height: 214px;
            margin-left: 25px;
            margin-right: 5px;
            overflow: hidden;
            display: flex;
            &-item {
                width: 289px;
                min-width: 289px;
                // height: 174px;
                margin-right: 20px;
                background: #ffffff;
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
                border-radius: 8px;
                position: relative;
                padding: 18px 19px 18px 27px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 4px;

                .img {
                    width: 70px;
                    height: 70px;
                }
                .title {
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #000000;
                    line-height: 28px;
                    margin-top: 8px;
                    margin-bottom: 8px;
                }

                .content {
                    font-size: 0.875rem;
                    color: #000000;
                    line-height: 20px;
                }

                &:before {
                    content: '';
                    background: #2f9458;
                    width: 8px;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    border-top-left-radius: 8px;
                    border-bottom-left-radius: 8px;
                }
            }
        }
    }
}

.qualification {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 43px;

    &-top {
        display: flex;
    }
    &-item {
        .item-title {
            font-size: 1.5rem;
            font-weight: bold;
            color: #157e3b;
            line-height: 32px;
            position: relative;
            margin-bottom: 26px;
            padding-left: 18px;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 6px;
                height: 30px;
                background: #2f9458;
            }
        }

        .img-1 {
            width: 544px;
            height: 239px;
            margin-left: 50px;
        }
        .img-2 {
            width: 266px;
            height: 239px;
            margin-left: 50px;
        }
    }

    .mr100 {
        margin-right: 100px;
    }
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 768px) {
    .slider_img {
        height: 137px;
        width: 100%;
    }
    .font_size_30 {
        font-size: 0.9375rem; // 15px
    }

    .font_size_14 {
        font-size: 0.625rem; // 10px
    }

    .solve {
        width: 100%;
        padding-top: 14px;
        padding-bottom: 14px;
        position: relative;
        .f-label {
            text-align: center;
            color: #157e3b;
        }

        .s-label {
            text-align: center;
            color: #aaaaaa;
            margin-top: 6px;
        }

        .more-img {
            position: absolute;
            right: 16px;
            top: 20px;
            width: 48px;
            height: 20px;
            background-image: url('../../assets/main/pic_more_nor@2x.png');
            background-size: 100% 100%;
        }
    }

    .profile {
        width: 100%;
        flex-direction: column;
        align-items: center;
        margin-top: 0;
        margin-bottom: 17px;
        .left-img {
            width: 343px;
            height: 261px;
            margin-bottom: 16px;
        }
        .right {
            margin: 0 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .content {
                width: 100%;
                font-size: 0.75rem;
                color: #333333;
                line-height: 18px;
                margin: 0;
            }
            .right-bottom-img {
                width: 353px;
                height: 122px;
                margin-top: 8px;
            }
        }
    }

    .mode {
        width: 100%;
        .mode-top {
            width: 100%;
            margin-top: 0px;
            flex-direction: column;
            align-items: center;
            .mode-top-left {
                padding: 0 16px;
                margin-bottom: 10px;
                .title {
                    font-size: 1rem;
                }
                .content {
                    font-size: 0.75rem;
                    margin-top: 4px;
                    line-height: 18px;
                    width: auto;
                }
            }
            .mode-top-img {
                width: 343px;
                height: 256px;
                margin: 0;
            }
        }

        .mode-bottom-mobile {
            width: calc(100% - 32px);
            padding: 10px 16px 0 16px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .mode-bottom-box-item {
                position: relative;
                padding: 13px 10px;
                height: auto;
                width: calc(50% - 28px);
                min-width: auto;
                margin-right: 0;
                margin-bottom: 16px;
                &:before {
                    width: 100%;
                    height: 8px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    border-top-right-radius: 8px;
                    border-bottom-left-radius: 0px;
                }
                .title {
                    font-size: 0.875rem;
                    line-height: 20px;
                }
                .content {
                    font-size: 0.75rem;
                    line-height: 17px;
                }
            }

            .mode-bottom-box-item-lone {
                width: 100%;
            }
        }
    }

    .qualification {
        width: 100%;
        margin-bottom: 10px;
        .qualification-top {
            width: calc(100% - 32px);
            padding: 0 16px;
            flex-direction: column;
            .qualification-item {
                width: 100%;
                .item-title {
                    font-size: 0.8125rem;
                    line-height: 20px;
                    padding-left: 9px;
                    margin-bottom: 10px;
                    &:before {
                        height: 100%;
                    }
                }
                .img-1 {
                    width: 343px;
                    height: 151px;
                    display: block;
                    margin: 0 auto;
                    margin-bottom: 18px;
                }
                .img-2 {
                    width: 266px;
                    height: 239px;
                    display: block;
                    margin: 0 auto;
                }
            }
            .mr100 {
                margin-right: 0px;
            }
        }
    }
}

@media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
    .profile {
        width: 100%;
        display: flex;
        justify-content: space-around;
        .left-img {
            width: 329px;
            height: 250px;
        }

        .right {
            .content {
                width: 350px;
            }
            .right-bottom-img {
                width: 399px;
                height: 144px;
            }
        }
    }

    .mode {
        .mode-top {
            width: calc(100% - 100px);
            display: flex;
            justify-content: space-between;

            .mode-top-left {
                width: calc(100% - 400px);
                .content {
                    width: 100%;
                }
            }
            .mode-top-img {
                width: 350px;
                height: 260px;
                margin-left: 0;
            }
        }

        .mode-bottom {
            width: calc(100% - 20px);
            .mode-bottom-box {
                width: calc(100% - 104px);
                .mode-bottom-box-item {
                    width: calc(33.33% - 64px);
                    min-width: calc(33.33% - 64px);
                }
            }
        }
    }

    .qualification {
        .qualification-top {
            .qualification-item {
                .img-1 {
                    width: 400px;
                    height: 175px;
                }

                .img-2 {
                    width: 200px;
                    height: 179px;
                }
            }

            .mr100 {
                margin-right: 50px;
            }
        }
    }
}
</style>
